import React, { useCallback } from 'react'
import Masonry from 'component/waterfall/baseMasonry'
import { RULES } from 'component/waterfall/masonryApi'
import { Empty } from 'meinian-package/src/baseComponent'
import FolderCard from './folderCard'

type Props = {
  data?:any;
  refresh:()=>void
}

export default function SampleClothingList({ data, refresh }:Props) {
  const rule = RULES.M
  const getAutoColumnCount = useCallback((width) => {
    for (let i = 0; i < rule.widths.length; i++) {
      if (width >= rule.widths[i]) return rule.maxColumnCount - i
    }
  }, [rule])

  return <div style={{ paddingTop: 24 }}>
    {
      data.length ? <Masonry
        gutter={12}
        data={data}
        columnCount={getAutoColumnCount}
        renderItem={(item, width) => <FolderCard
          {...item}
          onRefresh={refresh}
          id={item.id}
          lastImageUrl={item.lastImageUrl}
          topFlag={item.topFlag}
          columnWidth={width}
          sampleClothingNum={item.sampleClothingNum}
          userName={item.userName}
        />}
      /> : <Empty type="image" />
    }
  </div>
}
